<div>
    <div class="d-flex flex-row-reverse">
        <nav aria-label="Page navigation example">
            <ul class="pagination">
              <li class="page-item"><a [ngClass]="previousButton" (click)="navigatePreviousPage()" 
                [queryParams]="{ status: status, page: previousPage, size: size }" routerLink="/inventory">
                Previous
              </a></li>
              <li class="page-item"><a [ngClass]="nextButton" (click)="navigateNextPage()" 
                [queryParams]="{ status: status, page: nextPage, size: size }" routerLink="/inventory">
                Next
              </a></li>
            </ul>
          </nav>
    </div>
</div>
